module.exports = __webpack_public_path__ + "img/thumb_up_&_thumb_down_disable.c06aebdc.svg";